import React, { useState, useRef, useEffect } from 'react';
import ImageWmsLayer from './ImageWmsLayer';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';
import {cloneDeep} from "lodash";

export default function(props) {
    const {
        data,
        features,
        url,
        params,
        afterGetData,
        style,
        markerStyle,
        zIndex,
        id: key,
        _key,
        children,
        renderMode,
        show = true,
        layerControl = true,
        method,
        legend,
        group,
        cluster,
        ...otherProps
    } = props;
    const layerRef = useRef();
    const { map, groupLayer } = useProps();

    useEffect(() => {
        let layer = new ImageWmsLayer({
            url,
            data,
            afterGetData,
            renderMode,
            features,
            params,
            style,
            markerStyle,
            zIndex,
            key: key || _key,
            show,
            layerControl,
            legend,
            group: group && cloneDeep(group),
            map,
            groupLayer,
            method,
            ...otherProps
        });
    }, []);

    return <></>;
}
